import * as Sentry from '@sentry/react';

const { VITE_ENV, VITE_SENTRY_DSN } = import.meta.env;

Sentry.init({
  enabled: VITE_ENV !== 'develop',
  dsn: VITE_SENTRY_DSN,
  environment: VITE_ENV,
  integrations: [],
  sendDefaultPii: true,
  tracePropagationTargets: ['localhost', 'https://api.featurebuddy.com'],
});
